import React from 'react';
import { AutoSizer, List, WindowScroller } from 'react-virtualized';
import TableNoSearchResults from '@shared/components/TableNoSearchResults';
import { WorkspacesListProps } from './WorkspacesList.type';
import classes from './WorkspacesList.module.scss';

const WorkspacesList: React.FC<WorkspacesListProps> = ({
  noSearchResults,
  rowCount,
  renderCard
}) => {
  if (noSearchResults) {
    return (
      <div className={classes.noSearchResults}>
        <TableNoSearchResults />
      </div>
    );
  }

  return (
    <AutoSizer disableHeight>
      {({ width }) => (
        <WindowScroller>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <List
              autoHeight
              height={height}
              isScrolling={isScrolling}
              onScroll={onChildScroll}
              scrollTop={scrollTop}
              rowCount={rowCount}
              rowHeight={143}
              width={width}
              style={{ height: '100% !important' }}
              rowRenderer={renderCard}
            />
          )}
        </WindowScroller>
      )}
    </AutoSizer>
  );
};

export default WorkspacesList;
